import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";
import { Badge, IconButton } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { Link } from "gatsby";
import React from "react";

type CartButtonProps = {
    quantity: number;
    onClick?: () => void;
}

export function CartButton({ quantity, onClick }: CartButtonProps) {
    const theme = useTheme();

    return (

        <IconButton style={{ color: theme.palette.common.white }} size="large" component={Link} aria-label={`Shopping cart has ${quantity} items`} onClick={onClick} to="/cart">
            <Badge badgeContent={quantity > 0 ? quantity : undefined} color="error">
                <ShoppingBagOutlined fontSize="inherit" />
            </Badge>
        </IconButton>
    )
}